"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.useCouponDialog = useCouponDialog;
var _react = _interopRequireWildcard(require("react"));
var _CouponAppliedDialog = _interopRequireDefault(require("../components/CouponAppliedDialog/CouponAppliedDialog"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // Find the applied coupon in availableCoupons / paymentLine / a coupon object.
const getAppliedCoupon = source => {
  if (!source) return null;
  if (!Array.isArray(source)) {
    return source.couponCode ? source : null;
  }
  // prefer isApplied when the list carries it
  const hasAppliedFlag = source.some(c => c && typeof c.isApplied !== 'undefined');
  if (hasAppliedFlag) {
    return source.find(c => c && c.isApplied && c.couponCode) || null;
  }
  return source.find(c => c && c.couponCode) || null;
};

// Coupon "applied" popup. Returns a `dialog` that opens once per coupon and
// dismisses itself — the design has no close icon.
function useCouponDialog(couponSource) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$autoOpen = options.autoOpen,
    autoOpen = _options$autoOpen === void 0 ? true : _options$autoOpen,
    _options$autoCloseMs = options.autoCloseMs,
    autoCloseMs = _options$autoCloseMs === void 0 ? 3000 : _options$autoCloseMs,
    _options$dialogProps = options.dialogProps,
    dialogProps = _options$dialogProps === void 0 ? {} : _options$dialogProps;
  const coupon = (0, _react.useMemo)(() => getAppliedCoupon(couponSource), [couponSource]);
  const _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  const shownForRef = (0, _react.useRef)(null);
  const canShow = !!coupon;
  (0, _react.useEffect)(() => {
    if (!autoOpen) return;
    if (!canShow) {
      shownForRef.current = null;
      return;
    }
    if (shownForRef.current !== coupon.couponCode) {
      shownForRef.current = coupon.couponCode;
      setOpen(true);
    }
  }, [autoOpen, canShow, coupon]);
  const close = (0, _react.useCallback)(() => setOpen(false), []);
  const openDialog = (0, _react.useCallback)(() => setOpen(true), []);
  (0, _react.useEffect)(() => {
    if (!open || !autoCloseMs) return undefined;
    const timer = setTimeout(() => setOpen(false), autoCloseMs);
    return () => clearTimeout(timer);
  }, [open, autoCloseMs]);
  const dialog = canShow ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponAppliedDialog.default, _objectSpread({
    open: open,
    onClose: close,
    couponCode: coupon.couponCode,
    discountValue: coupon.discountValue
  }, dialogProps)) : null;
  return {
    dialog,
    open,
    close,
    openDialog,
    coupon
  };
}
var _default = exports.default = useCouponDialog;